import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Admin dev server (3001) does not host public ROI pages.
 * Send /roi/* traffic to the public frontend (REACT_APP_USER_LINK, default 3000).
 */
const RedirectToPublicFrontend = () => {
  const location = useLocation();

  useEffect(() => {
    const base = (
      process.env.REACT_APP_USER_LINK || "http://localhost:3000"
    ).replace(/\/$/, "");
    window.location.replace(
      `${base}${location.pathname}${location.search}${location.hash}`
    );
  }, [location]);

  return (
    <div style={{ padding: "2rem", fontFamily: "sans-serif" }}>
      Redirecting to the public calculator…
    </div>
  );
};

export default RedirectToPublicFrontend;
